function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.951 4.691a1 1 0 00-1.902 0l-2.245 6.91H5.539a1 1 0 00-.588 1.809l5.878 4.27-2.246 6.91a1 1 0 001.54 1.118L16 21.438l5.878 4.27a1 1 0 001.539-1.118l-2.245-6.91 5.877-4.27a1 1 0 00-.587-1.81h-7.266l-2.245-6.909zm-2.47 8.219l1.52-4.674 1.518 4.674a1 1 0 00.95.69h4.915l-3.976 2.89a1 1 0 00-.363 1.117l1.519 4.674-3.976-2.888a1 1 0 00-1.176 0l-3.975 2.888 1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888h4.915a1 1 0 00.95-.691z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.485 8.929a1 1 0 11-1.414-1.414l2.121-2.122a1 1 0 011.415 1.415l-2.122 2.12zM8.93 8.929a1 1 0 000-1.414L6.807 5.393a1 1 0 10-1.414 1.415l2.12 2.121a1 1 0 001.415 0zM28.624 21.134a1 1 0 11-1 1.732l-2.598-1.5a1 1 0 011-1.732l2.598 1.5zM15.825 29.75a1 1 0 001-1v-3a1 1 0 00-2 0v3a1 1 0 001 1zM4.376 22.866a1 1 0 01-1-1.732l2.598-1.5a1 1 0 111 1.732l-2.598 1.5z",
  fill: "currentColor"
})));